import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { FixSessionRegisterDrawer } from '../../../../../../../../../../features/fix/session/fix-session-register-drawer';
import { FixSessionsTable } from '../../../../../../../../../../features/fix/session/fix-sessions-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/fix-session/_fix-session/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsOms,
      label: 'FIX Sessions',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsOms>,
  head: () => getPageHead('FIX Sessions'),
  component: FixSessionList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <FixSessionRegisterDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Register FIX Session" size="small" />} />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsOms}
    />
  );
}

function FixSessionList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FixSessionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
